import styled from "styled-components";

export const BookingOverviewContainer = styled.div`
  display: flex;
`;

export const LeftViewSectionContainer = styled.div`
  flex: 2.5;
`;

export const RightViewSectionContainer = styled.div`
  flex: 1.5;

  @media only screen and (max-width: 786px) {
    display: none;
  }
`;

export const MwebFooterContainer = styled.div`
  display: none;

  @media only screen and (max-width: 786px) {
    display: flex;
    flex-direction: column;
    padding: 0 1.5rem 1.5rem 1.5rem;
  }
`;

export const PriceBreakupSummaryContainer = styled.div`
  display: none;

  @media only screen and (max-width: 1000px) {
    display: flex;
    flex-direction: column;
    flex: 1;
    border: 1px solid #e3e2e0;
    border-radius: 16px;
    // margin: 2rem 0;s
  }
`;

export const PriceBreakupHeader = styled.div`
  display: none;

  @media only screen and (max-width: 1000px) {
    display: flex;
    background-color: #e3e2e0;
    // flex: 1;
    padding: 0.7rem 0;
    border-radius: 16px;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
  }
`;

export const PriceBreakup = styled.div`
  display: none;

  @media only screen and (max-width: 1000px) {
    display: flex;
    // flex: 1;
    margin: 1.5rem 0.7rem;
  }
`;

export const PriceBreakupTotal = styled.div`
  display: none;

  @media only screen and (max-width: 1000px) {
    display: flex;
    flex: 1;
    margin: 0.7rem;
  }
`;

export const PriceBreakupPrice = styled.div`
  display: none;

  @media only screen and (max-width: 1000px) {
    display: flex;
    flex: 1;
    justify-content: flex-end;
    margin: 0.7rem;
  }
`;

export const BookNowBtn = styled.button`
  display: flex;
  justify-content: center;
  background-color: ${(props) => (props.disabled ? "#E5E5E5" : "#34265c")};
  color: ${(props) => (props.disabled ? "#000000" : "#ffffff")};
  border: none;
  border-radius: 64px;
  align-items: center;
  font-weight: 500;
  font-size: 18px;
  padding: 1rem;
  font-family: Montserrat;
  margin-top: 2rem;
`;

export const BookingSummaryHeading = styled.div`
  display: flex;
  flex: 1;
  // flex-direction: column;
  justify-content: space-between;
`;

export const BookingSummaryTxt = styled.h3`
  display: flex;
  flex: 1;
  text-decoration: underline;
  color: #34255c;
`;

export const PriceBreakupDetails = styled.div`
  flex: 1;
`;

export const BookingSummaryIcon = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex: 1;
`;
